import { Link } from "react-router-dom";

/**
 * Gear link to product settings (Sidequest 5.B.2).
 */
export default function SettingsEntryLink({ className = "" }) {
  return (
    <Link
      to="/settings?tab=profile"
      className={className}
      title="Settings"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "13px",
        color: "var(--text-secondary)",
        textDecoration: "none",
      }}
    >
      <span aria-hidden style={{ fontSize: "16px", lineHeight: 1 }}>
        ⚙
      </span>
      <span className="hidden sm:inline">Settings</span>
    </Link>
  );
}
